var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "message-box"
  }, [_c("div", {
    staticClass: "message-content-wrapper"
  }, [_c("div", {
    staticClass: "message-content"
  }, [!_vm.filterThinkingFlow(_vm.question) ? _c("div", {
    staticClass: "other-third-query-wrapper"
  }, [_vm.isPc && _vm.showWebQueryTag && _vm.lastAnswer.webQueryList && _vm.lastAnswer.webQueryList.length > 0 ? _c("WebQuery", {
    attrs: {
      searching: _vm.lastAnswer.webQueryLoading,
      "result-list": _vm.lastAnswer.webQueryList
    }
  }) : _vm._e(), _vm.showLawQueryTag && !_vm.lastAnswer.webQueryLoading && _vm.lastAnswer.lawQueryList && _vm.lastAnswer.lawQueryList.length > 0 ? _c("LawQuery", {
    attrs: {
      searching: _vm.lastAnswer.LawQueryLoading,
      "result-list": _vm.lastAnswer.lawQueryList,
      "bg-color": _vm.bgColor
    }
  }) : _vm._e()], 1) : _vm._e(), _c("div", {
    staticClass: "markdown-render-content"
  }, [_c("span", {
    domProps: {
      innerHTML: _vm._s(_vm.renderMarkDown(_vm.lastAnswer))
    }
  }), _vm.aiLoading && _vm.answer.id === _vm.qaId ? _c("div", {
    staticStyle: {
      padding: "8px",
      display: "flex",
      "align-items": "center"
    }
  }, [_c("searching", {
    staticClass: "m-r-4",
    attrs: {
      type: 3,
      animation: false
    }
  }), _c("span", [_vm._v("正在请求...")])], 1) : _vm._e()]), _vm.currentAnswerEnd ? _c("guide-question", {
    staticClass: "m-t-36",
    attrs: {
      "data-list": _vm.lastAnswer.questionGuideList
    },
    on: {
      send: _vm.sendHandler
    }
  }) : _vm._e()], 1), _vm.showEvaluate && _vm.currentAnswerShowEvaluate ? _c("AiAnswerButton", {
    staticClass: "ai-answer-evaluate",
    attrs: {
      answer: _vm.lastAnswer,
      question: _vm.question
    }
  }) : _vm._e(), _c("div", {
    staticClass: "ai-disclaimers"
  }, [_vm._v("内容由AI生成")]), _c("law-dialog", {
    ref: "law-dialog-ref"
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };